/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReportDateRange {
    AllTime = 0
}

export function ReportDateRangeFromJSON(json: any): ReportDateRange {
    return ReportDateRangeFromJSONTyped(json, false);
}

export function ReportDateRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportDateRange {
    return json as ReportDateRange;
}

export function ReportDateRangeToJSON(value?: ReportDateRange | null): any {
    return value as any;
}

